document.addEventListener('DOMContentLoaded',(event)=>{

  let articles = document.querySelectorAll('.article-card-wrapper')
  
  document.querySelectorAll('.article-card-wrapper').forEach((item)=>{
    item.addEventListener('click', ()=> {

      item.classList.toggle('hovered');
      item.classList.add('active');

      
      /*
      articles.forEach((item)=>{
        if(!item.classList.contains('active')){
          item.classList.remove('hovered');
        }
      });
      item.classList.remove('active');
      */
      
    });

    item.addEventListener('transitionend',(event)=>{
      item.classList.remove('active');
    })
    
  });
})